import axios from 'axios';

const api = axios.create({
    baseURL: 'https://apicentral.adlim.com.br'
  
})


export default api;

